import React, { createContext, useContext } from 'react';

// FIXME temporary import fix to avoid circular dependency - context folder should not depend on hooks folder
// eslint-disable-next-line @change/sibling-module-imports
import type { PlatformDataMap } from 'src/app/pages/starterDashboardV2/shared/hooks/useFetchReadyToSharePostsByPlatform';
// eslint-disable-next-line @change/sibling-module-imports
import { useReadyToShare } from 'src/app/pages/starterDashboardV2/shared/hooks/useReadyToShare';
import type { ReadyToSharePostWithPlatform } from 'src/app/shared/api/readyToShare';

type ReadyToShareContextType = {
	data: {
		isOpen: boolean;
		shouldShowReadyToShareExperiment: boolean;
		isLoading: boolean;
		readyToSharePostsValue?: readonly ReadyToSharePostWithPlatform[];
		platformData: PlatformDataMap;
	};
	actions: {
		openSharePreviewModal: () => void;
		closeSharePreviewModal: () => void;
		trackView: (currentPosition: string) => void;
	};
};

const ReadyToShareContext = createContext<ReadyToShareContextType | undefined>(undefined);

export const useReadyToShareContext = () => {
	const context = useContext(ReadyToShareContext);
	if (context === undefined) {
		throw new Error('useReadyToShareContext must be used within a ReadyToShareProvider');
	}
	return context;
};

export const ReadyToShareProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const readyToShare = useReadyToShare();
	return <ReadyToShareContext.Provider value={readyToShare}>{children}</ReadyToShareContext.Provider>;
};
